// extracted by mini-css-extract-plugin
export default {"scrollableContainer":"withScroll_scrollableContainer__BM5-s"};